import React, { memo, ReactElement } from 'react'
import { Field, reduxForm } from 'redux-form'
import { Translate } from 'react-localize-redux'
import { Button, ButtonType } from '@digicert/dcone-common-ui'
import History from 'core/history/history'
import InputField from 'shared/components/fields/InputField'
import { SetupLicenseFormAdapter } from './SetupLicenseForm.constants'
import { ISetupLicenseFormOwnProps, ISetupLicenseFormValues, TSetupLicenseFormProps } from '../License.interfaces'
import validate from './validate'
import styles from '../style/License.module.scss'

function SetupLicenseForm (props: TSetupLicenseFormProps): ReactElement {
  const { fields } = SetupLicenseFormAdapter
  const { mode } = props
  return (
    <form className={styles.form}>
      <Field
        id='licenseInput'
        name={fields.body as string}
        type='textarea'
        placeholder='common.form.enterLicense'
        rows={4}
        required
        component={InputField}
      />
      {mode === 'update' &&
      <div className={styles.actions}>
        <Button buttonType={ButtonType.SECONDARY} onClick={(e) => {
          e.preventDefault()
          History.goBack()
        }}>
          <Translate id='common.form.buttons.cancelBtn'/>
        </Button>

        <Button onClick={props.handleSubmit}>
          <Translate id='common.form.buttons.updateLicense' />
        </Button>
      </div>
      }
      {mode === 'setup' &&
        <Button onClick={props.handleSubmit}>
          <Translate id='common.form.buttons.submitBtn' />
        </Button>
      }
    </form>
  )
}

SetupLicenseForm.displayName = 'SetupLicenseForm'

export default reduxForm<ISetupLicenseFormValues, ISetupLicenseFormOwnProps>({
  form: SetupLicenseFormAdapter.name,
  validate
})(memo(SetupLicenseForm))
